import React, { useState, useEffect, useRef } from "react";
import "../../css/CRUDModal.css";
import DeleteConfirmationModal from "./DeleteConfirmationUser";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi, axiosGetApi } from "../../helpers/interceptorServices";
import confetti from "canvas-confetti";
import {isOperationRole} from "../../utils";

const UserModal = ({ show, handleClose, editData, action, fetchUserData }) => {
  console.log("UsereditData", editData);
  const loggedInUserName = sessionStorage.getItem("username");
  const loggedInUserRole = sessionStorage.getItem("userRole");
  const [roleOpen, setRoleOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState({ show: false, type: "" });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoadingUserName, setIsLoadingUserName] = useState(false);
  const roleRef = useRef(null);
  const profileRef = useRef(null);

  const toggleProfileDropdown = () => setProfileOpen(!profileOpen);
  const [codeLabel, setCodeLabel] = useState("Code");
  const [tableData, setTableData] = useState([]);

  const [formData, setFormData] = useState({
    username: loggedInUserName,
    // userId: "",
    name: "",
    mobileNo: "",
    emailId: "",
    userRole: [],
    userProfile: "",
    userCode: "",
    partnerSmsRate: "",
    partnerRcsRate: "",
    partnerRcsUtlRate: "",
    // selectedName: "",
  });
  const [selectedUserRole, setSelectedUserRole] = useState(""); // New state for the selected role
  const [errors, setErrors] = useState({
    // userId: "",
    name: "",
    mobileNo: "",
    emailId: "",
    userRole: "",
    userProfile: "",
    userCode: "",
    partnerSmsRate: "",
    partnerRcsRate: "",
    partnerRcsUtlRate: "",
    selectedName: "",
  });

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (action === "add") {
      setFormData({
        username: loggedInUserName,
        // userId: "",
        name: "",
        mobileNo: "",
        emailId: "",
        userRole: [], // Reset to empty array for a fresh start
        userProfile: "",
        partnerSmsRate: "",
        partnerRcsRate: "",
        partnerRcsUtlRate: "",
        selectedName: "",
      });
      setSelectedUserRole("");
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete"
    ) {
      setFormData({
        ...editData,
        username: loggedInUserName,
        selectedName: editData.customerName || "NULL",
        partnerSmsRate: editData.partnerSmsRate ?? "",
        partnerRcsRate: editData.partnerRcsRate ?? "",
        partnerRcsUtlRate: editData.partnerRcsUtlRate ?? "",
      });
      setSelectedUserRole(editData.userRole || editData.roleName); // Prefer role code (e.g. "PARTNER"); fall back to display name if code isn't present
    }
  }, [action, editData, loggedInUserName]);

  const handleClickOutside = (event) => {
    if (roleRef.current && !roleRef.current.contains(event.target)) {
      setRoleOpen(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setProfileOpen(false);
    }
  };

  const handleProfileChange = (event) => {
    const selectedProfile = event.target.value;
    toggleProfileDropdown();

    setFormData({
      ...formData,
      userProfile: selectedProfile,
      userRole: [],
    });

    setSelectedUserRole(""); // Clear selected role for other profiles

    setRoleOpen(false); // Close the dropdown if open

    if (selectedProfile !== "OPERATION") {
      let apiUrl = "";
      if (selectedProfile === "CUSTOMER") {
        apiUrl = apiList.ALL_ACTIVE_CUSTOMER_DATA;
      }
      const requestBody = {
        username: loggedInUserName,
      };

      axiosGetApi(apiUrl, requestBody)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            setTableData(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching retailer data:", error);
        });
    }

    if (selectedProfile === "") {
      setCodeLabel("Code");
    } else if (selectedProfile === "CUSTOMER") {
      setCodeLabel("Company Id");
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";

  const openModal = (type) => {
    setIsModalOpen({ show: true, type });
  };

  const closeModal = () => {
    setIsModalOpen({ show: false, type: "" });
  };

  const handleRole = () => {
    if (!formData.userProfile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        userProfile: "Please select a profile before selecting a role",
      }));
      return; // Exit the function to prevent further execution
    }
    setRoleOpen(!roleOpen);
    if (!formData.userProfile) return;
    setIsLoadingUserName(true);
    const requestBody = {
      username: loggedInUserName,
      userProfile: formData?.userProfile,
      status: "1",
    };

    axiosPostApi(apiList.MENU_USERROLE_DATA, requestBody)
      .then((response) => {
        if (
          response?.status === 200 &&
          response?.data?.data?.userRolesWithNames
        ) {
          const roles = response?.data?.data?.userRolesWithNames.map(
            (role) => ({
              userId: role.userRole,
              name: role.roleName,
            }),
          );
          setFormData((prevFormData) => ({
            ...prevFormData,
            userRole: roles,
          }));
          setIsLoadingUserName(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setIsLoadingUserName(false);
      });
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let updatedValue = value;
    if (id === "name") {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (id === "mobileNo") {
      updatedValue = value.replace(/[^0-9]/g, "");
    } else {
      updatedValue = value.trimStart(); // optional: prevent leading spaces
    }
    setFormData({ ...formData, [id]: updatedValue });
  };

  const validate = () => {
    const newErrors = {};

    // UserId validation
    // if (!formData.userId) {
    //   newErrors.userId = "User ID is required";
    // } else if (!/^[a-zA-Z0-9]+$/.test(formData.userId)) {
    //   newErrors.userId = "ID must be alphanumeric";
    // } else if (formData.userId.length < 5 || formData.userId.length > 10) {
    //   newErrors.userId = "UserId must be between 5 and 10 characters";
    // } else if (/^[0-9]/.test(formData.userId)) {
    //   newErrors.userId = "User ID cannot start with a number";
    // }

    formData.name = formData.name.trim();
    if (!formData.name) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.name)) {
      newErrors.name = "Name must contain only letters and spaces";
    } else if (formData.name.length < 2 || formData.name.length > 50) {
      newErrors.name = "Name must be between 2 and 50 characters long";
    } else {
      const nameWithoutSpaces = formData.name.replace(/\s+/g, "").toLowerCase();
      const firstChar = nameWithoutSpaces[0];
      const allSame = nameWithoutSpaces
        .split("")
        .every((char) => char === firstChar);

      if (allSame) {
        newErrors.name = "Name cannot consist of the same repeated letter";
      }
    }

    // Contact validation
    if (!formData.mobileNo) {
      newErrors.mobileNo = "Contact number is required";
    } else if (!/^[6789]\d{9}$/.test(formData.mobileNo)) {
      newErrors.mobileNo =
        "Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9";
    } else {
      const allSameDigit = formData.mobileNo
        .split("")
        .every((digit) => digit === formData.mobileNo[0]);
      if (allSameDigit) {
        newErrors.mobileNo = "Mobile number cannot have all digits the same";
      }
    }

    // Role validation
    if (!formData.userRole) {
      newErrors.userRole = "Role is required";
    }
    // Profile validation
    if (!formData.userProfile) {
      newErrors.userProfile = "Profile is required";
    }

    if (formData.userProfile !== "OPERATION") {
      if (!formData.userCode) {
        newErrors.userCode = "Company Id is required";
      }
    }

    // Partner rate validation
    if ((selectedUserRole || "").toUpperCase() === "PARTNER") {
      if (!formData.partnerSmsRate) {
        newErrors.partnerSmsRate = "Partner SMS Rate is required";
      } else if (!/^\d+(\.\d+)?$/.test(formData.partnerSmsRate)) {
        newErrors.partnerSmsRate = "Enter a valid rate";
      }

      if (!formData.partnerRcsRate) {
        newErrors.partnerRcsRate = "Partner RCS Promotional Rate is required";
      } else if (!/^\d+(\.\d+)?$/.test(formData.partnerRcsRate)) {
        newErrors.partnerRcsRate = "Enter a valid rate";
      }

      if (!formData.partnerRcsUtlRate) {
        newErrors.partnerRcsUtlRate = "Partner RCS Utility Rate is required";
      } else if (!/^\d+(\.\d+)?$/.test(formData.partnerRcsUtlRate)) {
        newErrors.partnerRcsUtlRate = "Enter a valid rate";
      }
    }

    // Email validation (required and valid email)
    if (!formData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|media|co\.[a-zA-Z]{2})$/.test(
        formData.emailId,
      ) ||
      /\.com\./.test(formData.emailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(formData.emailId)
    ) {
      newErrors.emailId =
        "Enter valid email ending with .com, .co.xx, .pe, .media or .in";
    }
    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value.trim();

    switch (id) {
      // case "userId":
      //   if (!trimmedValue) {
      //     fieldErrors.userId = "User ID is required";
      //   } else if (!/^[a-zA-Z0-9]+$/.test(trimmedValue)) {
      //     fieldErrors.userId = "ID must be alphanumeric";
      //   } else if (trimmedValue.length < 5 || trimmedValue.length > 10) {
      //     fieldErrors.userId = "UserId must be between 5 and 10 characters";
      //   } else if (/^[0-9]/.test(trimmedValue)) {
      //     fieldErrors.userId = "User ID cannot start with a number";
      //   } else {
      //     fieldErrors.userId = "";
      //   }
      //   break;

      case "name":
        if (!trimmedValue) {
          fieldErrors.name = "Name is required";
        } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(trimmedValue)) {
          fieldErrors.name = "Name must contain only letters and spaces";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 50) {
          fieldErrors.name = "Name must be between 2 and 50 characters long";
        } else {
          const nameWithoutSpaces = trimmedValue
            .replace(/\s+/g, "")
            .toLowerCase();
          const firstChar = nameWithoutSpaces[0];
          const allSame = nameWithoutSpaces
            .split("")
            .every((char) => char === firstChar);

          if (allSame) {
            fieldErrors.name =
              "Name cannot consist of the same repeated letter";
          } else {
            fieldErrors.name = "";
          }
        }
        break;

      case "mobileNo":
        if (!trimmedValue) {
          fieldErrors.mobileNo = "Contact number is required";
        } else if (!/^[6789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.mobileNo =
            "Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9";
        } else {
          const allSameDigit = trimmedValue
            .split("")
            .every((digit) => digit === trimmedValue[0]);
          if (allSameDigit) {
            fieldErrors.mobileNo =
              "Mobile number cannot have all digits the same";
          } else {
            fieldErrors.mobileNo = "";
          }
        }
        break;

      case "emailId":
        if (!trimmedValue) {
          fieldErrors.emailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|media|co\.[a-zA-Z]{2})$/.test(
            trimmedValue,
          ) ||
          /\.in\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.emailId =
            "Enter valid email ending with .com, .co.xx, .pe, .media or .in";
        } else {
          fieldErrors.emailId = "";
        }
        break;

      case "userCode":
        if (!trimmedValue) {
          fieldErrors.userCode = "Company Id is required";
        } else {
          fieldErrors.userCode = "";
        }
        break;

      case "partnerSmsRate":
        if (!trimmedValue) {
          fieldErrors.partnerSmsRate = "Partner SMS Rate is required";
        } else if (!/^\d+(\.\d+)?$/.test(trimmedValue)) {
          fieldErrors.partnerSmsRate = "Enter a valid rate";
        } else {
          fieldErrors.partnerSmsRate = "";
        }
        break;

      case "partnerRcsRate":
        if (!trimmedValue) {
          fieldErrors.partnerRcsRate = "Partner RCS Promotional Rate is required";
        } else if (!/^\d+(\.\d+)?$/.test(trimmedValue)) {
          fieldErrors.partnerRcsRate = "Enter a valid rate";
        } else {
          fieldErrors.partnerRcsRate = "";
        }
        break;

      case "partnerRcsUtlRate":
        if (!trimmedValue) {
          fieldErrors.partnerRcsUtlRate = "Partner RCS Utility Rate is required";
        } else if (!/^\d+(\.\d+)?$/.test(trimmedValue)) {
          fieldErrors.partnerRcsUtlRate = "Enter a valid rate";
        } else {
          fieldErrors.partnerRcsUtlRate = "";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const handleAddUser = (e) => {
    // e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);
      let apiUrl = "";
      let successMessage = "";

      if (action === "add") {
        apiUrl = apiList.CREATE_USER_DATA; // Add
        successMessage = "User added successfully";
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_USER_DATA; // Modify
        successMessage = "User details modified successfully";
      }
      const requestData = {
        ...formData,
        userRole: selectedUserRole,
      };

      axiosPostApi(apiUrl, requestData)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            // toast.success(successMessage, {
            //   position: "top-right",
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            // });
            CustomAlert({
              title: "Success",
              text: response?.data?.message || "User Added Successfully",
              icon: "success",
              confirmButtonText: "Ok",
            });
            const canvas = document.createElement("canvas");
            canvas.style.position = "fixed";
            canvas.style.top = "0";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            canvas.style.zIndex = "3000";
            document.body.appendChild(canvas);

            const confettiInstance = confetti.create(canvas, {
              resize: true,
              useWorker: true,
            });

            confettiInstance({
              particleCount: 250,
              spread: 100,
              origin: { y: 0.6 },
            });

            setTimeout(() => {
              document.body.removeChild(canvas);
            }, 3000);
            handleClose();
            fetchUserData(1);
          } else {
            CustomAlert({
              title:
                action === "add"
                  ? "Failed to Add User"
                  : "Failed to Modify User",
              text:
                response.data.message ||
                "There was an issue processing the request. Please try again.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing request:", error);
          CustomAlert({
            title: "Error",
            text:
              action === "add"
                ? "An error occurred while adding the user. Please try again later."
                : "An error occurred while modifying the user. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
    setCodeLabel("Code");
  };

  const handleRoleSelection = (event) => {
    const newRole = event.target.value;
    setSelectedUserRole(newRole);
    // setFormData(prevFormData => ({
    //     ...prevFormData,
    //     userRole: formData.userRole
    // }));

    if ((newRole || "").toUpperCase() !== "PARTNER") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        partnerSmsRate: "",
        partnerRcsRate: "",
        partnerRcsUtlRate: "",
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        partnerSmsRate: "",
        partnerRcsRate: "",
        partnerRcsUtlRate: "",
      }));
    }
  };

  const isPartnerRoleSelected = (selectedUserRole || "").toUpperCase() === "PARTNER";

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">
                {action.charAt(0).toUpperCase() + action.slice(1)} User Details
              </h5>
            </div>
            <form>
              <div className="scoped-modal modal-body">
                <div className="row mb-3">
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="userId">
                        User ID<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="userId"
                        value={formData?.userId || ""}
                        disabled={isViewMode || isDeleteMode || isEditMode}
                        placeholder="User ID"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) &&
                      errors.userId ? (
                        <span className="error">{errors.userId}</span>
                      ) : null}
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">
                        Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        id="name"
                        value={formData?.name || ""}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode) && errors.name ? (
                        <span className="error">{errors.name}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mobileNo">
                        Contact No.<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="mobileNo"
                        value={formData?.mobileNo || ""}
                        disabled={isViewMode || isDeleteMode}
                        placeholder="Contact No."
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                      />
                      {!(isViewMode || isDeleteMode) && errors.mobileNo ? (
                        <span className="error">{errors.mobileNo}</span>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="emailId">
                        User Email Id<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Id"
                        id="emailId"
                        value={formData?.emailId || ""}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        disabled={isViewMode || isDeleteMode}
                      />
                      {!(isViewMode || isDeleteMode) && errors.emailId ? (
                        <span className="error">{errors.emailId}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="userProfile">
                      User Profile<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      className="form-group position-relative"
                      ref={profileRef}
                    >
                      <select
                        className="form-control"
                        id="userProfile"
                        value={formData?.userProfile || ""}
                        disabled={isViewMode || isDeleteMode || isEditMode}
                        placeholder="Profile"
                        onChange={handleProfileChange}
                        onBlur={handleBlur}
                      >
                        <option value="" disabled selected>
                          Select Profile
                        </option>
                        <option value="CUSTOMER">CUSTOMER</option>
                        {
                          isOperationRole() && <option value="OPERATION">OPERATION</option>
                        }
                      </select>
                      <span className="position-absolute select-icon">
                        {profileOpen ? <ChevronUp /> : <ChevronDownIcon />}
                      </span>
                    </div>
                    {!(isViewMode || isDeleteMode || isEditMode) &&
                    errors.userProfile ? (
                      <span className="error">{errors.userProfile}</span>
                    ) : null}
                  </div>
                </div>
                <div className="row mb-3">
                  {/* Only show Role field if profile is not CUSTOMER */}
                  {
                    <div className="col-md-6">
                      <label htmlFor="userRole">
                        Role<span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        className="form-group position-relative"
                        ref={roleRef}
                      >
                        {isViewMode ? (
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.roleName || "N/A"}
                            readOnly
                          />
                        ) : (
                          <select
                            className="form-control"
                            id="userRole"
                            value={selectedUserRole}
                            placeholder="Role"
                            disabled={isViewMode || isDeleteMode || isEditMode}
                            onClick={handleRole}
                            onChange={handleRoleSelection}
                            onBlur={handleBlur}
                          >
                            <option value="" disabled={isViewMode}>
                              {isLoadingUserName
                                ? "Loading..."
                                : isEditMode
                                ? formData?.roleName || "Select Role"
                                : "Select Role"}
                            </option>
                            {!isLoadingUserName &&
                            Array.isArray(formData.userRole) &&
                            formData.userRole.length > 0
                              ? formData.userRole?.map((user) => (
                                  <option key={user.userId} value={user.userId}>
                                    {user.name}
                                  </option>
                                ))
                              : !isLoadingUserName && (
                                  <option value="" disabled>
                                    No data found
                                  </option>
                                )}
                          </select>
                        )}

                        <span className="position-absolute select-icon">
                          {roleOpen ? <ChevronUp /> : <ChevronDownIcon />}
                        </span>
                      </div>
                      {!(isViewMode || isDeleteMode || isEditMode) &&
                      errors.userRole ? (
                        <span className="error">{errors.userRole}</span>
                      ) : null}
                    </div>
                  }
                  {formData?.userProfile !== "OPERATION" && (
                    // <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="userCode">
                          {/* {codeLabel} */}
                          Company Id
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="userCode"
                          // placeholder={`Select ${formData.userProfile.toLowerCase()} Id`}
                          placeholder={`Select Company Id`}
                          value={formData?.userCode || ""}
                          onChange={handleInputChange}
                          disabled={isViewMode || isDeleteMode || isEditMode}
                          onClick={() => openModal("table")}
                          // onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode || isEditMode) &&
                        errors.userCode ? (
                          <span className="error">{errors.userCode}</span>
                        ) : null}
                      </div>
                    </div>
                    // </div>
                  )}
                </div>
                {isPartnerRoleSelected && (
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerSmsRate">
                          Partner SMS Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerSmsRate"
                          placeholder="Partner SMS Rate"
                          value={formData?.partnerSmsRate || ""}
                          disabled={isViewMode || isDeleteMode || isEditMode}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode || isEditMode) &&
                        errors.partnerSmsRate ? (
                          <span className="error">
                            {errors.partnerSmsRate}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerRcsRate">
                          Partner RCS Promotional Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerRcsRate"
                          placeholder="Partner RCS Promotional Rate"
                          value={formData?.partnerRcsRate || ""}
                          disabled={isViewMode || isDeleteMode || isEditMode}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode || isEditMode) &&
                        errors.partnerRcsRate ? (
                          <span className="error">
                            {errors.partnerRcsRate}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                )}
                {isPartnerRoleSelected && (
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="partnerRcsUtlRate">
                          Partner RCS Utility Rate
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="partnerRcsUtlRate"
                          placeholder="Partner RCS Utility Rate"
                          value={formData?.partnerRcsUtlRate || ""}
                          disabled={isViewMode || isDeleteMode || isEditMode}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        {!(isViewMode || isDeleteMode || isEditMode) &&
                        errors.partnerRcsUtlRate ? (
                          <span className="error">
                            {errors.partnerRcsUtlRate}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mb-3">
                  {formData?.userProfile !== "OPERATION" && (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="selectedName">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="selectedName"
                          placeholder="Selected Name"
                          value={formData?.selectedName || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="scoped-modal modal-footer">
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Back
                </button>
                {!isViewMode && !isDeleteMode && (
                  <div
                    // type="submit"
                    className="btn btn-submit"
                    onClick={() => handleAddUser()}
                  >
                    {isEditMode ? "Update" : "Submit"}
                  </div>
                )}
                {isDeleteMode && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => openModal("delete")}
                  >
                    Delete
                  </button>
                )}
                <DeleteConfirmationModal
                  isOpen={isModalOpen.show}
                  onClose={closeModal}
                  fetchUserData={fetchUserData}
                  editData={editData}
                  handleClose={handleBack}
                  mode={isModalOpen.type}
                  tableDataUser={tableData}
                  setFormData={setFormData}
                  formData={formData}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
      {isModalOpen.show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default UserModal;
